<app-section #parentSection
             [formGroup]="formGroup"
             [formConfig]="formConfig"
             [sectionRef]="section"
             class="contact-insurer-data-section"
             [title]="title | translate"
             [containerClass]="false">

    <ng-template #section>
        <div class="section__col section__col--3 section__col--custom-rwd"
             [ngClass]="{
                'section__col--3': isNext,
                'section__col--2': !isNext
             }">
            <div *ngIf="canFieldDisplayed(consts.EMAIL)" class="section__field">
                <app-text-field [errorsMap]="formFactoryService.errorsMap"
                                [control]="formGroup.controls[consts.EMAIL]"
                                [fieldConfig]="formFactoryService.fieldConfig(consts.EMAIL, formConfig)"
                                [context]="formConfig.formKey"
                                [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.EMAIL)]"
                                (markAsDirty)="markAsDirty($event)"
                                (changeEvent)="onFieldChange($event)"
                                (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-text-field>
            </div>

            <div *ngIf="canFieldDisplayed(consts.PHONE_NUMBER)"
                 class="section__field email-phone-component__telephone-number">
                <app-telephone-number-field [errorsMap]="formFactoryService.errorsMap"
                                            [control]="formGroup.controls[consts.PHONE_NUMBER]"
                                            [fieldConfig]="formFactoryService.fieldConfig(consts.PHONE_NUMBER, formConfig)"
                                            [context]="formConfig.formKey"
                                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.PHONE_NUMBER)]"
                                            (markAsDirty)="markAsDirty($event)"
                                            class="email-phone-component__telephone-number-field"
                                            (changeEvent)="onFieldChange($event)"
                                            (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-telephone-number-field>
            </div>
        </div>
    </ng-template>
</app-section>
